module.exports = __webpack_public_path__ + "img/attention.f58f4c21.svg";